/**
 * Script de traducción automática para elementos de Shopify
 * Traduce elementos generados automáticamente por Shopify que no se pueden modificar desde el tema
 */

(function() {
  'use strict';

  // Diccionario de traducciones
  const translations = {
    // Filtros de colección
    'Availability': 'Disponibilidad',
    'Price': 'Precio',
    'Product type': 'Tipo de producto',
    'Brand': 'Marca',
    'Color': 'Color',
    'Size': 'Talla',
    
    // Botones de pago dinámico
    'Buy it now': 'Comprar ahora 🤘',
    'More payment options': 'Más opciones de pago',
    
    // Carrito y checkout
    'Shipping': 'Envío',
    'shipping': 'envío',
    'calculated at checkout': 'calculados al finalizar la compra',
    'Calculated at checkout': 'Calculados al finalizar la compra',
    'Subtotal': 'Subtotal',
    'Total': 'Total',
    'Taxes': 'Impuestos',
    'View cart': 'Ver carrito',
    'Continue shopping': 'Continuar comprando',
    'Remove': 'Eliminar',
    'Update': 'Actualizar',
    'Quantity': 'Cantidad',
    'Add to cart': 'Agregar al carrito',
    
    // Estados de stock
    'Sold out': 'Agotado',
    'Unavailable': 'No disponible',
    'In stock': 'En stock',
    'Out of stock': 'Agotado',
    'Low stock': 'Pocas existencias',
    
    // Checkout y pago
    'Continue to checkout': 'Continuar al pago',
    'Proceed to checkout': 'Proceder al pago',
    'Check out': 'Finalizar compra',
    'Checkout': 'Pagar',
    
    // Cuenta de usuario
    'Log in': 'Iniciar sesión',
    'Log out': 'Cerrar sesión',
    'Sign in': 'Iniciar sesión',
    'Create account': 'Crear cuenta',
    'My account': 'Mi cuenta',
    'Account': 'Cuenta',
    
    // Otros
    'Search': 'Buscar',
    'Filter': 'Filtrar',
    'Sort': 'Ordenar',
    'Best selling': 'Más vendidos',
    'Price, low to high': 'Precio: de menor a mayor',
    'Price, high to low': 'Precio: de mayor a menor'
  };

  /**
   * Traduce el contenido de texto de un elemento
   */
  function translateElement(element) {
    if (!element || !element.textContent) return;
    
    const originalText = element.textContent.trim();
    
    // Buscar traducción exacta
    if (translations[originalText]) {
      element.textContent = translations[originalText];
      return;
    }
    
    // Buscar traducción parcial (si el texto contiene la palabra clave)
    for (const [key, value] of Object.entries(translations)) {
      if (originalText.includes(key)) {
        element.textContent = element.textContent.replace(key, value);
      }
    }
  }

  /**
   * Traduce los filtros de la colección
   */
  function translateFilters() {
    // Traducir etiquetas de filtros en el encabezado de cada filtro
    const filterLabels = document.querySelectorAll(
      '.facet-filters__label, .facets__label, details[id^="Details-"] summary span, .mobile-facets__label'
    );
    
    filterLabels.forEach(label => {
      translateElement(label);
    });

    // Traducir también los filtros en mobile
    const mobileFacets = document.querySelectorAll('.mobile-facets__label span');
    mobileFacets.forEach(label => {
      translateElement(label);
    });
  }

  /**
   * Texto final deseado para el botón de pago dinámico ("Buy it now").
   * Se fuerza sin depender del idioma de la tienda.
   */
  const DYNAMIC_BUY_TEXT = 'Comprar ahora 👉';

  /**
   * Aplica el emoji al botón dinámico de Shopify, sin importar si Shopify
   * lo renderizó en inglés ("Buy it now") o ya en español ("Comprar ahora").
   * El texto del botón --unbranded suele ser un nodo de texto directo, no un <span>.
   */
  function forceDynamicBuyEmoji() {
    const buttons = document.querySelectorAll('.shopify-payment-button__button--unbranded');
    buttons.forEach((button) => {
      const current = (button.textContent || '').trim();
      // Si ya tiene el texto deseado, no tocar (evita bucles con el observer).
      if (current === DYNAMIC_BUY_TEXT) return;
      // Reemplazar cuando dice "Buy it now" (inglés) o "Comprar ahora" (español),
      // o cualquier variante que aún no tenga el emoji.
      if (
        current === 'Buy it now' ||
        current === 'Comprar ahora' ||
        (current.length > 0 && !current.includes('🤘'))
      ) {
        button.textContent = DYNAMIC_BUY_TEXT;
      }
    });
  }

  /**
   * Traduce los botones de pago dinámico (Buy it now) — fuerza el emoji
   */
  function translateDynamicCheckoutButtons() {
    // Aplicar de inmediato por si el botón ya existe.
    forceDynamicBuyEmoji();

    // Observar cambios: Shopify (re)renderiza el botón de forma asíncrona.
    const observer = new MutationObserver(() => {
      forceDynamicBuyEmoji();
    });

    const paymentContainers = document.querySelectorAll(
      '.shopify-payment-button, .payment-buttons, [data-shopify="payment-button"]'
    );
    paymentContainers.forEach((container) => {
      observer.observe(container, {
        childList: true,
        subtree: true,
        characterData: true // detectar también cambios de texto
      });
    });

    // Si aún no existe el contenedor, observar el documento hasta que aparezca.
    if (paymentContainers.length === 0) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Reintento por intervalos durante los primeros segundos (red lenta / render tardío).
    let retries = 0;
    const retryInterval = setInterval(() => {
      forceDynamicBuyEmoji();
      retries++;
      if (retries >= 16) clearInterval(retryInterval); // ~8 s
    }, 500);
  }

  /**
   * Traduce elementos del checkout
   */
  function translateCheckoutElements() {
    // Traducir botones de checkout
    const checkoutButtons = document.querySelectorAll(
      '.cart__checkout-button, [name="checkout"], button[type="submit"]'
    );
    checkoutButtons.forEach(button => translateElement(button));
  }

  /**
   * Inicializa las traducciones
   */
  function init() {
    // Traducir filtros
    translateFilters();
    
    // Traducir botones de pago dinámico
    translateDynamicCheckoutButtons();
    
    // Traducir elementos de checkout
    translateCheckoutElements();
    
    // Re-ejecutar las traducciones cuando cambie el contenido (para filtros AJAX)
    const contentObserver = new MutationObserver(() => {
      translateFilters();
      translateCheckoutElements();
    });
    
    // Observar cambios en el contenedor principal de productos
    const mainContent = document.querySelector('#MainContent, main, .facets-container');
    if (mainContent) {
      contentObserver.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // También ejecutar después de un pequeño delay para asegurar que todo esté cargado
  setTimeout(init, 500);
  setTimeout(translateDynamicCheckoutButtons, 1000);
  setTimeout(translateDynamicCheckoutButtons, 2000);
})();
